// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProductReport":"eo_a bhm_a bhm_x bhm_j bhm_u bhm_bc bhm_ql bhm_vv"};